import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pages: {}
};

const visibleColumnsSlice = createSlice({
  name: "visibleColumns",
  initialState,
  reducers: {
    initColumns: (state, action) => {
      const { pageKey, columns } = action.payload;

      if (!state.pages[pageKey]) {
        state.pages[pageKey] = {};
      }
      // Backfill any column key that hasn't been seeded yet so newly added
      // columns appear for users with previously persisted visibility state.
      columns.forEach(col => {
        if (state.pages[pageKey][col] === undefined) {
          state.pages[pageKey][col] = true;
        }
      });
    },

    toggleColumn: (state, action) => {
      const { pageKey, column,value } = action.payload;

      const page = state.pages[pageKey];
      if (!page) return;

      page[column] = value ?? !page[column];
    },

    setColumnVisibility: (state, action) => {
      const { pageKey, column, value } = action.payload;

      if (!state.pages[pageKey]) {
        state.pages[pageKey] = {};
      }

      state.pages[pageKey][column] = value;
    },

    updateMultipleColumns: (state, action) => {
      const { pageKey, updates } = action.payload;
      if (!state.pages[pageKey]) {
        state.pages[pageKey] = {};
      }

      state.pages[pageKey] = {
        ...state.pages[pageKey],
        ...updates,
      };
    },


    resetColumns: (state, action) => {
      const { pageKey } = action.payload;
      delete state.pages[pageKey];
    }
  }
});

export const {
  initColumns,
  toggleColumn,
  setColumnVisibility,
  resetColumns,
  updateMultipleColumns
} = visibleColumnsSlice.actions;

export default visibleColumnsSlice.reducer;
